import { reactive, readonly } from 'vue';

export enum Decisions {
  // Test features, do not use in production code
  TEST_FEATURE = 'TEST_FEATURE',
  TEST_FEATURE_2 = 'TEST_FEATURE_2',
  // End test features

  // Keep the string in camelCase since it goes through a transformation in the http service
  SIGNER_AREA_CTA = 'callToActionEnabled',
  POSITION_SIGN = 'togglePositionSignEnabled',
  SIGNATURE_POSITION_SIGN = 'togglePositionSignatureWidgetEnabled',
  SIGNER_AREA_RECEIPTS_TABS = 'toggleSignerReceiptsTabEnabled',
  UPDATE_CAF_LIVENESS_SDK = 'toggleUpgradeFaceLivenessSdkTo140Enabled',
  UPDATE_CAF_DOCUMENT_DETECTOR_SDK = 'toggleUpgradeDocumentDetectorSdkTo5142Enabled',
  EMAIL_EMBED_TOKEN = 'toggleSendEmbedTokenInSignatureRequest',
  AUTOFILL_SIGNER_DATA = 'toggleAutofillSignerDataEnabled',
  TOGGLE_NEXT_CODE_IMPLEMENTATION = 'toggleNextCodeImplementation',
  TOGGLE_LIVENESS_WITH_STRATEGY_ENABLED = 'toggleLivenessWithStrategyEnabled',
  TOGGLE_SHOW_SIGNER_NAME_ON_WIDGET_ENABLED = 'toggleShowSignerNameOnWidgetEnabled',
  STORY_NEW_UNAVAILABLE_PAGE = 'storyNewUnavailablePage',
  REUSABLE_MANUSCRIPT = 'reusableManuscript',
  EXPERIMENT_DOCUMENT_AI_SUMMARY = 'experimentDocumentAiSummary',
  OCR_SYNC = 'ocrSync',
  TOGGLE_FACEMATCH_RETRIES_LIMIT = 'toggleFacematchRetriesLimit',
  SIGNER_AREA_SHORTCUT = 'signerAreaShortcut',
}

export enum DecisionStatus {
  DISABLED = 0,
}

const decisions = reactive(new Map<Decisions, number>());

function getValWithDefault(decision: Decisions) {
  return decisions.get(decision) ?? DecisionStatus.DISABLED;
}

function setFeature(decision: Decisions, scopeOrStatus: boolean | number) {
  decisions.set(decision, +scopeOrStatus);
}

function isEnabled(decision: Decisions) {
  return getValWithDefault(decision) > DecisionStatus.DISABLED;
}

function isScopeEnabled(decision: Decisions, scope: number) {
  if (!isEnabled(decision)) return false;

  return getValWithDefault(decision) >= scope;
}

function enableFeature(key: Decisions) {
  setFeature(key, true);
}

function disableFeature(key: Decisions) {
  setFeature(key, false);
}

export const features = {
  isEnabled,
  isScopeEnabled,
  setFeature,
  enableFeature,
  disableFeature,
  decisions: readonly(decisions),
};
